<template>
  <v-container fluid class="pa-0">
    <v-card max-width="400" class="mx-auto elevation-4 rounded-xl overflow-hidden glass-card theme-aware-card ticket-modal-card">
      <v-card-text class="pa-0">
        <!-- Ticket Header Accent -->
        <div class="ticket-accent-bar mb-2"></div>
        
        <!-- Ticket Content Container (Preserved for logic) -->
        <div class="ticket-content-wrapper px-4">
          <div v-html="tiqueteReport.adicional" ref="element" id="ticket" class="modern-ticket-display"></div>
        </div>

        <v-divider class="mx-4 my-2 opacity-50"></v-divider>

        <v-card-actions class="px-4 py-4 d-flex justify-space-around actions-grid">
          <v-btn fab small depressed color="blue" dark @click="share" class="action-fab">
            <v-icon>mdi-share-variant</v-icon>
            <span class="sr-only">Compartir</span>
          </v-btn>
          
          <v-btn fab small depressed color="indigo" dark @click="print" class="action-fab">
            <v-icon>mdi-printer</v-icon>
            <span class="sr-only">Imprimir</span>
          </v-btn>

          <v-btn fab small depressed color="blue-grey" dark @click="printTicket" class="action-fab">
            <v-icon>mdi-bluetooth</v-icon>
            <span class="sr-only">Bluetooth</span>
          </v-btn>

          <v-btn fab small depressed color="orange darken-2" dark @click="selected" class="action-fab">
            <v-icon>mdi-refresh</v-icon>
            <span class="sr-only">Repetir</span>
          </v-btn>
        </v-card-actions>

        <div class="px-4 pb-6 mt-2">
          <v-btn color="error" block depressed x-large @click="close()" class="rounded-xl close-btn-elite">
            <v-icon left>mdi-close-circle-outline</v-icon>
            TERMINAR Y CERRAR
          </v-btn>
        </div>
      </v-card-text>
    </v-card>
  </v-container>
</template>
<script>
import axios from "axios";
import html2canvas from "html2canvas";
import { mapGetters } from "vuex";

export default {
  props: {
    tiqueteInfo: {
      idTiquete: "",
      tipoTiquete: "",
      reimpresion: "",
    },
    allwedOnly: {
      type: Boolean,
      default: true,
    },
  },
  data: () => ({
    itemsPerPage: 4,
    tiqueteReport: [],
    info: "",
    printerCharacteristic: null,
    isConnected: false,
    tiqueteReport2: {
      bancaNombre: 'My Bank',
      nombre: 'John Doe',
      sorteo: '12345',
      tiquete: 'A12345',
      fechaVenta: '2024-08-10',
      items: [
        { numero: '001', monto: '10.00' },
        { numero: '002', monto: '15.00' },
      ],
      total: '25.00',
      porcPaga: '1',
    }
  }),
  computed: {
    ...mapGetters(["strCia"]),
  },

  created() {
    this.getTiqueteReport();
    this.$vuetify.theme.dark = false;
    this.generarTiqueteReport();
  },
  methods: {

    async connectToPrinter() {
      try {
        const device = await navigator.bluetooth.requestDevice({
          filters: [{ services: ['printer_service'] }] // Replace with your printer's service UUID
        });

        const server = await device.gatt.connect();
        const service = await server.getPrimaryService('printer_service'); // Replace with your printer's service UUID
        const characteristic = await service.getCharacteristic('printer_characteristic'); // Replace with your printer's characteristic UUID

        this.printerCharacteristic = characteristic;
        this.isConnected = true;
        console.log('Connected to printer');
      } catch (error) {
        console.error('Error connecting to Bluetooth device:', error);
        this.isConnected = false;
      }
    },

    async printTicket2() {
      if (!this.printerCharacteristic) {
        console.log('No printer connected');
        return;
      }

      const ticketData = this.generateTicketData();
      const encoder = new TextEncoder();
      const encodedData = encoder.encode(ticketData);

      try {
        await this.printerCharacteristic.writeValue(encodedData);
        console.log('Print job sent');
      } catch (error) {
        console.error('Error sending print job:', error);
      }
    },

    generateTicketData() {
      // Generate the ticket data in the required format
      return `
        ${this.padCenter(this.tiqueteReport.bancaNombre, 32)}
        ${this.padCenter(this.tiqueteReport.nombre, 32)}
        ${this.padCenter(this.tiqueteReport.sorteo, 32)}
        ------------------------------
        ${this.padCenter(this.tiqueteReport.tiquete, 32)}
        ${this.padCenter(this.tiqueteReport.fechaVenta, 32)}
        ------------------------------
        Número    Monto
        ${this.tiqueteReport.items.map(item => `${this.padRight(item.numero, 10)} ${this.padLeft(item.monto, 10)}`).join('\n')}
        ------------------------------
        Total: ${this.padLeft(this.tiqueteReport.total, 32)}
        ------------------------------
        REVISE SIEMPRE SU TIQUETE
        Se paga ${this.tiqueteReport.porcPaga} veces
        GRACIAS POR JUGAR!
      `;
    },

    padRight(text, length) {
      return (text + ' '.repeat(length)).substring(0, length);
    },

    padLeft(text, length) {
      return (' '.repeat(length) + text).substring(text.length, length);
    },

    padCenter(text, length) {
      const spaces = length - text.length;
      const padLeft = Math.floor(spaces / 2);
      const padRight = spaces - padLeft;
      return ' '.repeat(padLeft) + text + ' '.repeat(padRight);
    },

    getTiqueteReport() {
      this.snackValue = false;
      let me = this;
      axios
        .get(
          "api/Tiempos/GetTiquete" + this.tiqueteInfo.tipoTiquete + "Report?idTiquete=" + this.tiqueteInfo.idTiquete +
          "&companyId=" +
          this.strCia +
          "&reimpresion=" +
          this.tiqueteInfo.reimpresion
        )
        .then(function (response) {
          me.tiqueteReport = response.data;
          //console.log(me.tiqueteReport.bancaNombre);
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    generarTiqueteReport() {
      //const fecha = new Date().toLocaleDateString();
      // Construyendo la cadena HTML de la tabla con los valores dinámicos
      //console.log(this.tiqueteReport.bancaNombre);
      let tablaHTML = '<table class="item">';
      tablaHTML += '<thead><tr><th>Número</th><th>Monto</th></tr></thead>';
      tablaHTML += '<tbody>';

      // Agregando dinámicamente filas a la tabla para cada producto
      this.tiqueteReport.forEach(num => {
        tablaHTML += `<tr>
                  <td>${num.numero}</td>
                  <td>${num.monto}</td>
                </tr>`;
      });

      tablaHTML += '</tbody></table>';

      this.info = `<!DOCTYPE html>
<html lang="en">
<head>
  <meta charset="UTF-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <title>Tiquete</title>
  <style>
    body {
      font-family: Arial, sans-serif;
      font-size: 13px;
    }
    .ticket {
      width: 250px;
      margin: 0 auto;
      /* border: 1px solid #000; */
      padding: 0px;
    }
    .header {
      font-weight: bold;
      text-align: center; 
      font-size: 13px;
    }
    .item {
      text-align: center; 
      margin-bottom: 1px;
      font-size: 12px;
    }
    .item:last-child {
      margin-bottom: 0;
    }
    .total {
      font-weight: bold;
      text-align: center; 
      font-size: 13px;
    }
    .footer {
      margin-top: 5px;
      text-align: center; 
    }
  </style>
</head>
<body>

<div class="ticket">
    <div class="header">
        <span>${this.tiqueteReport.bancaNombre}</span>
    </div>
    <div class="header">
        <span>${this.tiqueteReport.nombre}</span>
    </div>
    <div class="header">
        <span>${this.tiqueteReport.sorteo}</span>
    </div>
    <hr>
  
  <div class="item">
    <span>${this.tiqueteReport.tiquete}</span>
  </div>
  <div class="item">
    <span>${this.tiqueteReport.fechaVenta}</span>
  </div>

  <div class="line"></div>

  <hr>

  ${tablaHTML} <!-- Aquí se inserta la tabla dinámica -->

<hr>

  <div class="total">
    <span>Total:</span> <span>${this.tiqueteReport.total}</span>
  </div>
  <hr>
  <div class="footer">
    <span>REVISE SIEMPRE SU TIQUETE</span>
    <span>Se paga</span><span>${this.tiqueteReport.porcPaga}</span><span> veces</span>
    <span>GRACIAS POR JUGAR!</span>
  </div>
</div>

</body>
</html>
`;
    },

    selected() {
      this.dialog = false;
      this.$emit("clicked");
    },

    close() {
      this.dialog = false;
      this.$emit("closed");
    },

    share() {
      // iife here
      (async () => {
        if (!("share" in navigator)) {
          console.log("Sharing not supported");
          return;
        }
        // `element` is the HTML element you want to share.
        // `backgroundColor` is the desired background color.
        const canvas = await html2canvas(this.$refs.element);

        canvas.toBlob(async (blob) => {
          // Even if you want to share just one file you need to
          // send them as an array of files.
          const files = [new File([blob], "image.png", { type: blob.type })];
          const shareData = {
            text: "",
            title: "",
            files,
          };
          if (navigator.canShare(shareData)) {
            try {
              await navigator.share(shareData);
            } catch (err) {
              if (err.name !== "AbortError") {
                console.error(err.name, err.message);
              }
            }
          } else {
            console.warn("Sharing not supported", shareData);
          }
        });
      })();
    },

    printTicket() {
      // Use HTML2Canvas to generate an image of the ticket
      html2canvas(this.$refs.element).then(function (canvas) {
        const imageData = canvas.toDataURL('image/png');
        // Create a new window for printing
        const printWindow = window.open('', '_blank');
        printWindow.document.write('<img src="' + imageData + '">');
        // Print the ticket
        printWindow.print();
      });
    },

    printContent: function () {
      // var self = this;
      // Capture the target element
      html2canvas(this.$refs.element).then(function (canvas) {
        // Create an image from the captured canvas
        var imgData = canvas.toDataURL('image/png');
        // Create a new window for printing
        var printWindow = window.open('', '_blank');
        printWindow.document.open();
        printWindow.document.write('<html><head><title>Print</title></head><body>');
        //printWindow.document.write('<style>@page { size: 100mm 150mm; margin: 0; }</style>');
        //printWindow.document.write('<style>@page { size: 80mm auto; margin: 0; }</style>');
        printWindow.document.write('<style>@page {height:279mm; width:80mm; }</style>');
        printWindow.document.write('<img src="' + imgData + '" style="width: 100%; height: 100%;"/>');
        printWindow.document.write('</body></html>');
        printWindow.document.close();

        // Wait for image to load before printing
        printWindow.onload = function () {
          printWindow.focus(); // Focus on new window
          printWindow.print(); // Print the window
          printWindow.close(); // Close the window after printing
        };
      });
    },

    print: function () {
      const element = window.document.getElementById("ticket");//const ticketElem = this.$refs.element;
      var printPreview = window.open('', 'print_preview');
      var printDocument = printPreview.document;
      printDocument.open();
      printDocument.write(`<!DOCTYPE html>
<html lang="en">
<head>
  <meta charset="UTF-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <title>Tiquete</title>
  <style>
    body {
      font-family: Arial, sans-serif;
      font-size: 13px;
    }
    .ticket {
      width: 250px;
      margin: 0 auto;
      /* border: 1px solid #000; */
      padding: 0px;
    }
    .item {
      text-align: center; 
      margin-bottom: 1px;
      font-size: 13px;
    }
    .item:last-child {
      margin-bottom: 0;
    }
    .footer {
      margin-top: 5px;
      text-align: center; 
    }
  </style>
</head>
<body>
<div class="ticket">
    <div class="item">
        <span>${element.innerHTML}</span>
    </div>
</body>
</html>
`);

      // printDocument.write(`
      //   <html>
      //     <head>
      //       <title></title>
      //     </head>
      //     <body>
      //       ${element.innerHTML}
      //     </body>
      //   </html>
      // `);
      printPreview.print();
      printPreview.close();

    },
  },
};
</script>

<style>
/* Ticket Modal Specific Styles */
.ticket-modal-card {
  border: 1px solid rgba(255, 255, 255, 0.1) !important;
  background: white !important; /* Forces high contrast for the ticket area */
}

.ticket-accent-bar {
  height: 6px;
  background: linear-gradient(90deg, #2563eb, #3b82f6);
}

.ticket-content-wrapper {
  background: white;
  min-height: 200px;
}

/* Modern styling for the injected HTML content */
.modern-ticket-display >>> .ticket {
  width: 100% !important;
  max-width: 300px;
  margin: 0 auto;
  padding: 10px 0;
  color: #1a1a1a !important;
}

.modern-ticket-display >>> table.item {
  width: 100%;
  border-collapse: collapse;
  margin: 15px 0;
}

.modern-ticket-display >>> table.item th {
  border-bottom: 2px solid #e2e8f0;
  padding: 8px 4px;
  color: #475569;
  text-transform: uppercase;
  font-size: 11px;
}

.modern-ticket-display >>> table.item td {
  padding: 8px 4px;
  font-size: 14px;
  font-weight: 600;
}

.modern-ticket-display >>> .header {
  font-weight: 800;
  font-size: 16px;
  margin-bottom: 4px;
  color: #1a1a1a;
}

.modern-ticket-display >>> hr {
  border: none;
  border-top: 1px dashed #cbd5e1;
  margin: 10px 0;
}

.modern-ticket-display >>> .total {
  font-size: 18px;
  display: flex;
  justify-content: space-between;
  padding-top: 5px;
}

.action-fab {
  transition: all 0.3s ease;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1) !important;
}

.action-fab:hover {
  transform: translateY(-2px);
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1) !important;
}

.close-btn-elite {
  font-weight: 900 !important;
  letter-spacing: 1px;
  box-shadow: 0 4px 6px -1px rgba(239, 68, 68, 0.2) !important;
}

.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  border: 0;
}

/* Glass card overrides for the modal if needed */
.theme--dark .ticket-modal-card {
  /* We keep it light for the ticket content contrast, 
     but we could darken the surrounding container if desired. */
  background: #f8fafc !important; 
}
</style>